import { render, staticRenderFns } from "./DataGovDecisionTable.vue?vue&type=template&id=ff2a00d4"
import script from "./DataGovDecisionTable.vue?vue&type=script&lang=js"
export * from "./DataGovDecisionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports